<template>
  <div class="d-flex justify-end user-actions-wrapper align-center">
    <layout-user-actions-send-homework v-if="showHomeworkButton" />
    <layout-user-actions-global-annotation-button v-if="showGlobalAnnotationButton" />
    <layout-user-actions-pdf-playlist-button v-if="showPdfPlaylistButton" />
    <layout-user-actions-profile-menu />
  </div>
</template>

<script lang="ts">
import constants from "~/constants"
import { usePdfStore } from "~/stores/pdfStore"
import { useSmartPageStore } from "~/stores/smartPageStore"
import { useUserStore } from "~/stores/userStore"
import { anyPatternMatches } from "~/utils/pathMatch"

export default {
  setup() {
    const userStore = useUserStore()
    const smartPageStore = useSmartPageStore()
    const pdfStore = usePdfStore()
    return { userStore, smartPageStore, pdfStore }
  },

  computed: {
    showHomeworkButton(): boolean {
      const showBasedOnRoute = anyPatternMatches(this.$route.path, constants.HOMEWORK_BUTTON_PATHS)
      return (
        !this.$vuetify.display.xs &&
        showBasedOnRoute &&
        this.userStore.isTeacher &&
        this.userStore.isEklaseUser
      )
    },

    showGlobalAnnotationButton(): boolean {
      return (
        !this.$vuetify.display.xs &&
        this.userStore.isTeacherWithActiveSchoolAndProPlan
      )
    },

    showPdfPlaylistButton(): boolean {
      return this.pdfStore.currentFile
    },
  },
}
</script>

<style lang="sass">
.user-actions-wrapper
  gap: 24px
</style>
